import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ILogger } from '@nimbus-library/features/logger/services/logger/i-logger';
import { NimbusIcon } from '@nimbus-library/features/shared/directives/nimbus-icon.directive';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { LicenseItemDisableReasonTranslationMapper } from '@nimbus-library/features/shared/components/material/input-license/input-license.model';
import { BaseUserInputLicenseCheckboxItemComponent } from '../base/base-user-input-license-checkbox-item-component.directive';

@Component({
  standalone: false,
  selector: 'nimbus-user-input-license-modality-checkbox-item',
  templateUrl: './user-input-license-modality-checkbox-item.component.html',
  styleUrls: ['./user-input-license-modality-checkbox-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInputLicenseModalityCheckboxItemComponent extends BaseUserInputLicenseCheckboxItemComponent implements OnChanges {
  @Input() public icon: NimbusIcon;
  @Input() public infoLabel: string;
  @Input() public infoLabelLink: string;
  @Input() public linkValue: string;

  protected readonly translationMapper = LicenseItemDisableReasonTranslationMapper;

  public readonly ICONS = ICONS;

  public constructor(
    protected readonly changeDetectionRef: ChangeDetectorRef,
    protected readonly loggerService: ILogger,
    protected readonly translateService: TranslateService,
  ) {
    super(changeDetectionRef, loggerService, translateService);
  }

  public ngOnChanges(e: SimpleChanges): void {
    super.ngOnChanges(e);
  }
}
